import { useEffect, useRef } from "react";
import styles from "./mapStyles.json";

function Map(props) {
    const mapRef = useRef(null);
    const { setGMap, promoCountry } = props;
    
    useEffect(() => {
        const map = new window.google.maps.Map(mapRef.current, {
            center: promoCountry,
            zoom: 10,
            styles: styles.mapStyles
        });
        setGMap(map);
        
    }, [setGMap, promoCountry]);

    return <div className="map-container" id="gmap" ref={mapRef} style={{height: "345px", width: "100%", maxWidth: "100%"}}/>
}

export default Map;